import React from "react";

function MainImg() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            fill="none"
            viewBox="0 0 526 400"
        >
            <g clipPath="url(#clip0_0_34450)">
                <path
                    fill="#91B3FA"
                    d="M117.652 163.203c-11.018-11.316-3.512-30.045-18.392-39.954-6.715-4.471-14.962-2.055-16.767 6.095-1.682 7.595 4.942 14.215 1.847 21.964-4.83 12.087-17.741 17.885-10.466 31.812 5.185 9.93 19.817 12.565 23.754 23.392 1.872 5.146-.863 8.666-1.62 13.774-1.27 8.595 4.412 14.782 8.929 21.318 4.567 6.611 4.012 9.6 1.91 17.516-2.378 8.967-3.272 17.114-1.812 26.027 1.449 8.847-2.743 16.424-4.099 25.106-1.562 10.022 1.353 20.592 6.972 28.763 5.998 8.721 14.647 13.171 24.501 17.534 2.783 1.234 11.699 7.4 11.639 1.192-.063-6.584-14.554-10.681-18.569-14.96-19.262-20.523 18.764-38.807 8.547-60.144-2.136-4.459-5.836-9.314-5.293-14.566.647-6.257 6.948-10.032 9.734-15.512 4.807-9.455 1.196-19.76-2.603-28.379-2.717-6.161-6.223-12.129-6.637-19.023-.362-6.04 2.612-11.928 2.333-17.879-.326-6.998-5.158-15.085-13.914-24.079l.006.003z"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M131.426 351.44a.682.682 0 01-.42-.042c-.192-.084-19.199-8.715-20.405-27.623-.545-8.541 2.63-20.091 5.698-31.261 3.653-13.288 7.425-27.029 4.43-34.522-5.779-14.449-10.982-28.286-11.186-38.78-.066-3.448.135-6.95.33-10.338.306-5.315.62-10.81-.108-16.124-.645-4.702-3.056-8.592-5.614-12.712-2.327-3.754-4.735-7.634-5.644-12.159-.783-3.905-.705-8.064-.63-12.085.108-5.732.22-11.655-2.21-16.772-1.937-4.087-7.086-14.941-9.213-15.145-.069-.006-.215-.021-.431.273a.679.679 0 01-1.092-.805c.555-.756 1.206-.861 1.652-.819 2.133.204 4.832 4.37 10.308 15.914 2.563 5.405 2.45 11.493 2.339 17.378-.075 3.949-.15 8.033.605 11.791.861 4.285 3.203 8.06 5.467 11.709 2.516 4.057 5.122 8.252 5.803 13.243.747 5.446.426 11.007.117 16.388-.192 3.361-.393 6.839-.327 10.233.198 10.266 5.359 23.974 11.09 38.303 3.167 7.916-.501 21.258-4.381 35.383-3.041 11.062-6.184 22.501-5.653 30.814 1.154 18.08 19.415 26.389 19.6 26.47a.68.68 0 01.345.895.676.676 0 01-.473.387l.003.006z"
                ></path>
                <path
                    fill="#BDD0FB"
                    d="M143.991 334.085c-.45-1.818-.855-3.463-1.071-4.735-3.913-23.107-12.964-46.532-27.946-64.87-24.204-29.622-14.548-40.287-30.01-47.621-15.462-7.334-19.049 4.135-39.657-8.601-20.605-12.732-60.832 3.706-39 15.77 9.674 5.345 20.824 4.948 30.837 9.078 14.931 6.154 9.98 17.852 14.617 30.33 3.658 9.839 13.767 14.956 22.593 19.052 12.181 5.654 25.913 8.547 36.421 17.525 11.999 10.257 15.064 26.132 22.918 39.063 1.748 2.878 5.368 10.389 8.852 11.136 6.403 1.372 2.402-12.273 1.449-16.127h-.003z"
                ></path>
                <path
                    fill="#91B3FA"
                    d="M140.986 333.368a.821.821 0 01-1.146-.48c-6.699-20.202-14.307-36.446-23.259-49.656-2.864-4.225-6.75-6.338-10.862-8.573-1.961-1.065-3.988-2.17-5.968-3.535-3.457-2.389-6.681-5.288-9.578-8.616-3.29-3.775-5.94-8.075-8.502-12.231-3.164-5.135-6.438-10.443-10.895-14.678-7.998-7.598-17.999-12.543-27.616-16.754-10.523-4.609-23.733-9.311-32.562-4.684a.807.807 0 01-1.113-.348.827.827 0 01.348-1.113c9.453-4.952 23.125-.124 33.986 4.633 9.756 4.27 19.91 9.294 28.09 17.069 4.613 4.381 7.942 9.783 11.163 15.007 2.528 4.103 5.143 8.343 8.343 12.016 2.81 3.223 5.928 6.029 9.275 8.342 1.907 1.318 3.896 2.398 5.818 3.442 4.294 2.335 8.352 4.541 11.441 9.099 9.038 13.339 16.712 29.712 23.46 50.061a.822.822 0 01-.42.999h-.003z"
                ></path>
                <path
                    fill="url(#paint0_linear_0_34450)"
                    d="M113.255 46.727l17.49 309.751h291.007l12.551-309.751H113.255z"
                ></path>
                <path
                    fill="url(#paint1_linear_0_34450)"
                    d="M435.406 53.005H111.723a3.585 3.585 0 01-3.428-2.533l-1.976-6.425c-.711-2.308 1.017-4.645 3.428-4.645h326.649a3.588 3.588 0 013.544 4.135l-.986 6.425a3.587 3.587 0 01-3.545 3.043h-.003z"
                ></path>
                <path
                    fill="url(#paint2_linear_0_34450)"
                    d="M435.406 149.279H111.723a3.585 3.585 0 01-3.428-2.533l-1.976-6.425c-.711-2.307 1.017-4.645 3.428-4.645h326.649c2.198 0 3.88 1.96 3.544 4.135l-.986 6.425a3.587 3.587 0 01-3.545 3.043h-.003z"
                ></path>
                <path
                    fill="#91B3FA"
                    d="M431.505 115.792l1.778-43.95H114.674l2.48 43.95h314.351z"
                ></path>
                <path
                    fill="url(#paint3_linear_0_34450)"
                    d="M157.177 71.841h-7.32v43.951h7.32v-43.95z"
                ></path>
                <path
                    fill="url(#paint4_linear_0_34450)"
                    d="M207.372 71.841h-7.32v43.951h7.32v-43.95z"
                ></path>
                <path
                    fill="url(#paint5_linear_0_34450)"
                    d="M257.57 71.841h-7.32v43.951h7.32v-43.95z"
                ></path>
                <path
                    fill="url(#paint6_linear_0_34450)"
                    d="M307.765 71.841h-7.32v43.951h7.32v-43.95z"
                ></path>
                <path
                    fill="url(#paint7_linear_0_34450)"
                    d="M357.963 71.841h-7.32v43.951h7.32v-43.95z"
                ></path>
                <path
                    fill="url(#paint8_linear_0_34450)"
                    d="M408.158 71.841h-7.32v43.951h7.32v-43.95z"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M167.055 355.917l-6.933-168.809 227.419-5.816-6.75 174.625H167.055z"
                ></path>
                <path
                    fill="#BDD0FB"
                    d="M174.396 356.289l-7.341-154.57h213.736l-7.923 154.588-198.472-.018z"
                ></path>
                <mask
                    id="mask0_0_34450"
                    style={{ maskType: "luminance" }}
                    width="214"
                    height="156"
                    x="167"
                    y="201"
                    maskUnits="userSpaceOnUse"
                >
                    <path
                        fill="#fff"
                        d="M174.396 356.289l-7.341-154.57h213.736l-7.923 154.588-198.472-.018z"
                    ></path>
                </mask>
                <g fill="#91B3FA" mask="url(#mask0_0_34450)">
                    <path d="M385.226 214.404H162.428v6.674h222.798v-6.674zM385.226 227.086H162.428v6.008h222.798v-6.008zM385.226 239.768H162.428v6.008h222.798v-6.008zM385.226 252.453H162.428v6.007h222.798v-6.007zM385.226 265.134H162.428v6.008h222.798v-6.008zM385.226 277.816H162.428v6.008h222.798v-6.008zM385.226 290.501H162.428v5.341h222.798v-5.341zM385.226 303.183H162.428v6.007h222.798v-6.007zM385.226 315.864H162.428v5.342h222.798v-5.342zM385.226 327.88H162.428v6.008h222.798v-6.008zM385.226 341.231H162.428v4.672h222.798v-4.672z"></path>
                </g>
                <path
                    fill="#91B3FA"
                    d="M392.036 167.677H156.949a4.53 4.53 0 00-4.528 4.532v30.321a4.53 4.53 0 004.528 4.531h235.087a4.53 4.53 0 004.529-4.531v-30.321a4.53 4.53 0 00-4.529-4.532z"
                ></path>
                <path
                    fill="url(#paint9_linear_0_34450)"
                    d="M398.568 203.031a6.034 6.034 0 01-6.031 6.035h-235.42a6.034 6.034 0 01-6.031-6.035v-31.32a6.034 6.034 0 016.031-6.035h235.42a6.034 6.034 0 016.031 6.035v31.32zm-3.335-31.657a3.028 3.028 0 00-3.029-3.03h-235.42a3.029 3.029 0 00-3.029 3.03v30.654a3.03 3.03 0 003.029 3.031h235.42a3.029 3.029 0 003.029-3.031v-30.654z"
                ></path>
                <path
                    fill="#91B3FA"
                    d="M423.783 350.575H129.209a4.806 4.806 0 00-4.804 4.808v1.731a4.806 4.806 0 004.804 4.808h294.574a4.806 4.806 0 004.804-4.808v-1.731a4.806 4.806 0 00-4.804-4.808z"
                ></path>
                <path
                    fill="url(#paint10_linear_0_34450)"
                    d="M497.342 330.784l23.424-6.346s5.539 1.605 4.723 9.848c-.815 8.244-24.177 6.74-24.177 6.74l-3.97-10.239v-.003z"
                ></path>
                <path
                    fill="url(#paint11_linear_0_34450)"
                    d="M289.142 240.077c-44.686 11.181-70.902 41.07-83.83 44.092-12.928 3.022-64.713 5.785-73.158 13.636-8.445 7.85-.378 13.429-11.234 23.524-12.01 33.916 25.179 44.065 25.179 44.065l338.069-2.749s22.812 2.053 23.319-14.251c.507-16.304-5.038-24.539-6.235-39.222-1.199-14.683-1.223-15.421-4.492-23.035-3.269-7.613-35.006-8.441-41.18-16.91-6.178-8.468-13.531-21.975-39.735-26.578-36.197-6.359-100.781-9.057-126.7-2.572h-.003z"
                ></path>
                <path
                    fill="url(#paint12_linear_0_34450)"
                    d="M509.298 347.427c-.581 18.741-32.333 15.419-32.471 15.407 0 0-25.245-19.338 9.482-18.594 10.436-.27 21.016-5.8 21.016-5.8l1.973 8.987z"
                ></path>
                <path
                    fill="url(#paint13_linear_0_34450)"
                    d="M118.86 329.704s-.333 4.781 8.616 9.663c11.093 6.053 49.607-.6 49.607-.6l4.397 24.799-36.299 1.852c.849.231-47.667-2.566-26.318-35.711l-.003-.003z"
                ></path>
                <path
                    fill="#91B3FA"
                    d="M449.852 293.772s1.088-8.511-7.845-18.945c-8.934-10.434-14.149-17.315-21.019-19.086-6.871-1.77-57.153-8.732-60.455-3.379-3.301 5.354-7.557 38.232-7.557 38.232l96.873 3.175.003.003z"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M420.079 254.841c-5.632-.84-48.402-5.816-59.447-4.396l-2.858 11.001 92.12 32.32s.441-7.005-4.163-13.91c-7.731-11.601-19.765-24.274-25.655-25.015h.003z"
                ></path>
                <path
                    fill="#91B3FA"
                    d="M345.494 252.356c-1.391 6.353-6.523 37.328-6.523 37.328l-108.724-.504s34.274-31.515 60.62-36.506c26.348-4.987 55.521-3.679 54.63-.321l-.003.003z"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M294.582 250.337c21.46-2.98 29.329-2.416 51.827-.444l-2.165 9.002s-33.483-6.572-64.68-2.773c0 0 8.013-4.816 15.018-5.788v.003z"
                ></path>
                <path
                    fill="url(#paint14_linear_0_34450)"
                    d="M134.661 296.184s17.616-5.65 21.913 8.286c4.097 13.285-35.653 16.859-35.653 16.859s2.929-19.707 13.74-25.145z"
                ></path>
                <path
                    fill="url(#paint15_linear_0_34450)"
                    d="M455.87 278.713c-.098 0-.197-.015-.296-.045-4.136-1.251-7.621-5.611-11.654-10.659-5.893-7.373-12.571-15.731-23.46-17.81-20.887-3.988-52.543-6.752-52.861-6.782a1.02 1.02 0 01-.93-1.108 1.006 1.006 0 011.107-.93c.317.027 32.082 2.8 53.068 6.809 11.632 2.221 18.863 11.272 24.674 18.543 3.821 4.78 7.123 8.909 10.649 9.978a1.022 1.022 0 01-.294 2.001l-.003.003z"
                ></path>
                <path
                    fill="url(#paint16_linear_0_34450)"
                    d="M488.243 290.318c-.378 0-.737-.21-.917-.571-1.716-3.46-9.312-5.029-16.659-6.548-2.627-.543-5.344-1.104-7.842-1.758a1.024 1.024 0 01.516-1.981c2.447.643 5.137 1.198 7.74 1.735 8.187 1.692 15.918 3.289 18.077 7.643a1.023 1.023 0 01-.915 1.48z"
                ></path>
                <path
                    fill="url(#paint17_linear_0_34450)"
                    d="M455.33 384.552c12.717-12.725 12.717-33.356 0-46.081-12.716-12.724-33.333-12.724-46.049 0-12.716 12.725-12.716 33.356 0 46.081 12.716 12.724 33.333 12.724 46.049 0z"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M411.892 361.679c.297 11.478 9.836 20.541 21.304 20.247 11.471-.298 20.527-9.843 20.233-21.319-.296-11.478-9.833-20.541-21.304-20.244-11.47.297-20.527 9.843-20.233 21.319v-.003z"
                ></path>
                <path
                    fill="url(#paint18_linear_0_34450)"
                    d="M210.616 390.305c16.99-5.898 25.986-24.461 20.093-41.463-5.894-17.001-24.444-26.003-41.435-20.106-16.99 5.898-25.986 24.461-20.092 41.463 5.893 17.001 24.444 26.003 41.434 20.106z"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M179.542 359.671c.297 11.478 9.837 20.541 21.304 20.247 11.471-.297 20.528-9.84 20.234-21.318-.297-11.479-9.836-20.541-21.304-20.244-11.471.297-20.527 9.843-20.234 21.318v-.003z"
                ></path>
                <path
                    fill="url(#paint19_linear_0_34450)"
                    d="M338.86 360.112h-.101c-.594 0-1.071-.261-1.062-.855.006-.432.264-.681.633-.849 2.117-3.409 4.864-40.188 6.111-62.902.033-.594.54-1.023 1.134-.987a1.088 1.088 0 011.014 1.149c-.009.159-.894 15.95-2.163 31.755-2.582 32.173-4.174 32.689-5.566 32.689z"
                ></path>
                <path
                    fill="url(#paint20_linear_0_34450)"
                    d="M265.67 298.393h-22.785a7.113 7.113 0 00-7.11 7.115v.261a7.112 7.112 0 007.11 7.115h22.785a7.113 7.113 0 007.111-7.115v-.261a7.114 7.114 0 00-7.111-7.115z"
                ></path>
                <path
                    fill="#91B3FA"
                    d="M78.445 146.332a2.3 2.3 0 01-.426-.042l-12.239-2.422a2.186 2.186 0 01-1.742-1.851l-1.317-9.582a46.544 46.544 0 01-11.353-7.58l-9.35 2.469a2.19 2.19 0 01-2.379-.897l-6.942-10.374a2.194 2.194 0 01.075-2.542l5.842-7.712a46.563 46.563 0 01-2.681-13.39l-8.352-4.867a2.192 2.192 0 01-1.047-2.317l2.42-12.247a2.187 2.187 0 011.85-1.743l9.576-1.317a46.544 46.544 0 017.575-11.362L45.487 49.2a2.194 2.194 0 01.897-2.38l10.367-6.946a2.184 2.184 0 012.54.075l7.707 5.845a46.46 46.46 0 0113.38-2.682l4.865-8.358a2.19 2.19 0 012.315-1.047l12.238 2.421c.915.18 1.617.925 1.743 1.85l1.316 9.58a46.532 46.532 0 0111.354 7.581l9.351-2.47a2.19 2.19 0 012.378.898l6.942 10.374a2.192 2.192 0 01-.075 2.541l-5.842 7.713a46.548 46.548 0 012.681 13.39l8.352 4.867a2.192 2.192 0 011.047 2.317l-2.42 12.246a2.187 2.187 0 01-1.848 1.744l-9.575 1.317a46.519 46.519 0 01-7.575 11.362l2.468 9.356a2.189 2.189 0 01-.9 2.38l-10.364 6.947a2.19 2.19 0 01-2.54-.075l-7.707-5.846a46.48 46.48 0 01-13.384 2.683l-4.864 8.358a2.194 2.194 0 01-1.892 1.089l.003.003zm-11.81-5.02l11.567 2.289 5.43-9.33.735-.027a43.848 43.848 0 0013.969-2.799l.69-.261 8.604 6.527 9.797-6.566-2.756-10.447.501-.54a43.924 43.924 0 007.905-11.859l.303-.672 10.688-1.471 2.288-11.574-9.324-5.432-.027-.735a43.903 43.903 0 00-2.798-13.978l-.261-.69 6.523-8.61-6.562-9.804-10.439 2.758-.539-.501a43.9 43.9 0 00-11.852-7.914l-.672-.303-1.47-10.695-11.566-2.29-5.428 9.33-.734.027a43.836 43.836 0 00-13.97 2.8l-.689.261-8.604-6.527-9.797 6.566 2.756 10.446-.501.54a43.89 43.89 0 00-7.905 11.86l-.303.672-10.688 1.474-2.288 11.574 9.323 5.432.028.735a43.999 43.999 0 002.797 13.978l.261.69-6.522 8.61 6.561 9.804 10.44-2.758.54.501a43.873 43.873 0 0011.85 7.913l.672.303 1.47 10.696-.003-.003zm16.428-20.016a31.787 31.787 0 01-12.556-2.593 1.335 1.335 0 011.058-2.452 28.964 28.964 0 005.85 1.819c7.54 1.491 15.208-.042 21.593-4.322 6.384-4.279 10.724-10.791 12.214-18.332 1.491-7.544-.042-15.218-4.318-21.606-4.277-6.39-10.784-10.732-18.32-12.223-7.54-1.494-15.208.042-21.592 4.321-6.385 4.28-10.724 10.791-12.215 18.333a28.739 28.739 0 001.134 15.292 1.333 1.333 0 11-2.51.904 31.429 31.429 0 01-1.239-16.712c1.629-8.244 6.37-15.359 13.348-20.034 6.979-4.676 15.358-6.353 23.596-4.724 8.237 1.63 15.348 6.374 20.02 13.357 4.672 6.983 6.349 15.368 4.72 23.611-1.628 8.244-6.369 15.359-13.348 20.034-5.236 3.508-11.264 5.33-17.43 5.33l-.005-.003z"
                ></path>
                <path
                    fill="#91B3FA"
                    d="M82.78 102.42c-6.552 0-12.043-5.156-12.388-11.776-.356-6.839 4.916-12.693 11.75-13.047 6.84-.351 12.685 4.918 13.04 11.757.356 6.84-4.916 12.694-11.75 13.048-.22.012-.438.018-.654.018h.003zm.013-22.17c-.171 0-.34.002-.513.011-5.365.28-9.503 4.874-9.225 10.246.28 5.368 4.874 9.506 10.239 9.23 5.365-.279 9.503-4.873 9.224-10.245-.27-5.197-4.582-9.243-9.725-9.243zM155.827 55.07a1.418 1.418 0 01-1.283-.823l-1.862-4.048a22.786 22.786 0 01-6.016-1.819l-3.794 2.34a1.407 1.407 0 01-1.634-.107l-4.642-3.805a1.415 1.415 0 01-.429-1.585l1.544-4.183a22.923 22.923 0 01-2.972-5.54l-4.336-1.029a1.412 1.412 0 01-1.08-1.233l-.596-5.978c-.06-.6.266-1.17.815-1.422l4.046-1.864c.324-2.08.935-4.1 1.817-6.02l-2.339-3.796a1.414 1.414 0 01.108-1.635l3.802-4.646a1.408 1.408 0 011.584-.429l4.18 1.546a22.83 22.83 0 015.536-2.974l1.026-4.34A1.412 1.412 0 01150.534.6l5.974-.594c.6-.057 1.17.267 1.422.813l1.862 4.051a22.81 22.81 0 016.016 1.819l3.793-2.344a1.409 1.409 0 011.635.111l4.642 3.802c.465.382.639 1.018.429 1.585l-1.545 4.183a22.73 22.73 0 012.972 5.54l4.336 1.026c.585.138 1.02.636 1.08 1.236l.597 5.975c.06.6-.267 1.17-.816 1.423l-4.045 1.863c-.324 2.08-.936 4.1-1.818 6.02l2.339 3.796c.318.513.273 1.17-.107 1.636l-3.8 4.645a1.412 1.412 0 01-1.583.429l-4.181-1.545a22.766 22.766 0 01-5.536 2.973l-1.028 4.337a1.411 1.411 0 01-1.233 1.08l-5.971.597c-.048.006-.093.006-.141.006v.006zm-9.278-8.973l.495.243c2.039.999 4.207 1.656 6.447 1.95l.549.072 2.147 4.664 5.134-.514 1.185-4.996.522-.18a20.738 20.738 0 005.934-3.187l.438-.336 4.816 1.78 3.269-3.995-2.696-4.372.243-.495a20.77 20.77 0 001.949-6.452l.072-.55 4.661-2.148-.513-5.137-4.993-1.183-.18-.522a20.788 20.788 0 00-3.185-5.939l-.336-.438 1.778-4.82-3.991-3.27-4.369 2.698-.495-.243a20.753 20.753 0 00-6.448-1.951l-.549-.072-2.147-4.663-5.134.513-1.181 4.996-.522.18a20.744 20.744 0 00-5.935 3.187l-.438.336-4.816-1.78-3.269 3.995 2.696 4.372-.243.495a20.796 20.796 0 00-1.949 6.452l-.072.55-4.66 2.148.513 5.138 4.993 1.185.18.522a20.76 20.76 0 003.184 5.939l.336.438-1.778 4.82 3.991 3.27 4.37-2.697-.003-.003zm9.743-3.178c-.585 0-1.166-.033-1.742-.1a1.001 1.001 0 01.225-1.989 13.52 13.52 0 002.873.018 13.393 13.393 0 009.092-4.876 13.401 13.401 0 002.981-9.882c-.738-7.4-7.356-12.823-14.748-12.082-7.396.738-12.812 7.358-12.074 14.759a13.465 13.465 0 002.588 6.7 1.002 1.002 0 01-1.607 1.195 15.464 15.464 0 01-2.972-7.697c-.846-8.499 5.374-16.103 13.867-16.953 8.496-.846 16.092 5.378 16.94 13.877.849 8.498-5.374 16.102-13.866 16.952-.516.05-1.035.078-1.554.078h-.003z"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M408.761 39.312l-9.59-4.7a2.38 2.38 0 00-2.642.37l-1.044.939-1.685 1.518-1.08.972a2.382 2.382 0 00-.642 2.59l3.671 10.035c.558 1.521 1.823 2.683 3.407 3.019l6.48 1.416 42.089 46.769 2.427-2.184 1.685-1.519 2.288-2.065-42.089-46.768-.684-6.644c-.171-1.612-1.139-3.04-2.594-3.751l.003.003z"
                ></path>
                <path
                    fill="url(#paint21_linear_0_34450)"
                    d="M408.11 39.879l-8.69-4.291c-.786-.385-1.782-.313-2.432.273l-.939.846-1.517 1.368-.972.877c-.651.585-.828 1.57-.525 2.391l3.332 9.069c.501 1.371 1.67 2.416 3.098 2.722l5.865 1.278 37.957 42.175 2.156-1.942 1.518-1.368 2.372-2.137-37.957-42.174-.771-5.843c-.152-1.453-1.181-2.599-2.492-3.241l-.003-.003z"
                ></path>
                <path
                    fill="url(#paint22_linear_0_34450)"
                    d="M482.134 112.281l-29.922-26.726L437.1 99.221l23.029 31.834a20.171 20.171 0 008.553 6.782l9.179 3.916c1.554.651 3.449.462 4.699-.663l6.283-5.663c1.137-1.023 1.547-2.689 1.254-4.189l-1.545-7.71c-.843-4.324-3.131-8.312-6.415-11.244l-.003-.003z"
                ></path>
                <path
                    fill="url(#paint23_linear_0_34450)"
                    d="M434.843 97.058l15.135-13.641a2.495 2.495 0 013.523.184l.185.205a2.5 2.5 0 01-.184 3.526l-15.137 13.643a2.495 2.495 0 01-3.523-.184l-.185-.205a2.5 2.5 0 01.184-3.526l.002-.002z"
                ></path>
                <path
                    fill="url(#paint24_linear_0_34450)"
                    d="M476.188 131.712a2.134 2.134 0 01-.159 3.013l-.033.027a2.13 2.13 0 01-3.011-.159l-28.525-31.695a2.133 2.133 0 01.159-3.013l.033-.027a2.128 2.128 0 013.01.159l28.526 31.695z"
                ></path>
                <path
                    fill="url(#paint25_linear_0_34450)"
                    d="M483.655 124.984a2.133 2.133 0 01-.159 3.013l-.033.027a2.13 2.13 0 01-3.011-.159L451.927 96.17a2.133 2.133 0 01.159-3.013l.033-.027a2.13 2.13 0 013.011.159l28.525 31.695z"
                ></path>
                <path
                    fill="url(#paint26_linear_0_34450)"
                    d="M388.384 110.736l-2.018 1.881c-3.464 3.232-4.508 7.745-2.331 10.083l2.588 2.779c2.178 2.338 6.751 1.611 10.215-1.618l2.018-1.881c.135-.126.264-.252.393-.381l57.443-58.41-5.638-6.052-62.262 53.238c-.138.12-.276.24-.408.367v-.006zm2.78 2.664c2.609-2.433 5.893-3.148 7.338-1.596 1.445 1.551.501 4.78-2.108 7.214s-5.893 3.148-7.338 1.596c-1.446-1.551-.501-4.78 2.108-7.214z"
                ></path>
                <path
                    fill="url(#paint27_linear_0_34450)"
                    d="M468.667 35.002l-11.714 10.926a3.685 3.685 0 00-1.155 3.034l.549 5.822a3.677 3.677 0 003.059 3.283l5.767.957a3.67 3.67 0 003.107-.939l11.713-10.926c1.767-1.648 4.688-.465 4.754 1.953.155 5.78-2.139 11.683-6.799 16.031-8.424 7.856-20.341 6.69-27.895-1.42-7.555-8.108-7.881-20.087.545-27.944 4.661-4.348 10.706-6.223 16.458-5.66 2.405.235 3.38 3.236 1.614 4.883h-.003z"
                ></path>
                <path
                    fill="url(#paint28_linear_0_34450)"
                    d="M469.695 36.106l-11.713 10.927a3.685 3.685 0 00-1.155 3.034l.549 5.821a3.675 3.675 0 003.059 3.283l5.767.958a3.667 3.667 0 003.106-.94l11.714-10.926c1.766-1.647 4.687-.465 4.753 1.954.156 5.78-2.138 11.682-6.798 16.03-8.424 7.857-20.342 6.69-27.896-1.42-7.554-8.108-7.881-20.087.546-27.943 4.66-4.349 10.706-6.224 16.458-5.66 2.405.234 3.38 3.235 1.613 4.882h-.003z"
                ></path>
                <path
                    fill="url(#paint29_linear_0_34450)"
                    d="M389.205 111.618l-2.018 1.881c-3.463 3.232-4.507 7.746-2.33 10.083l2.588 2.779c2.177 2.338 6.751 1.615 10.214-1.617l2.019-1.882c.134-.126.263-.252.392-.381l57.444-58.41-5.638-6.052-62.263 53.239c-.138.12-.276.24-.408.366v-.006zm2.78 2.665c2.609-2.434 5.893-3.148 7.339-1.597 1.445 1.552.501 4.781-2.109 7.214-2.609 2.434-5.892 3.148-7.338 1.597-1.445-1.552-.501-4.781 2.108-7.214z"
                ></path>
                <path
                    fill="url(#paint30_linear_0_34450)"
                    d="M93.517 380.98s-.807 4.325-1.22 8.607a2.956 2.956 0 002.791 3.229c5.704.291 17.904.87 22.285.717a.961.961 0 00.858-1.308 2.157 2.157 0 00-1.089-1.171L97.07 381.59l-3.553-.61z"
                ></path>
                <path
                    fill="url(#paint31_linear_0_34450)"
                    d="M92.914 378.43l.564 5.185s3.515 1.678 5.947-.15l-1.407-5.788-5.104.75v.003z"
                ></path>
                <path
                    fill="url(#paint32_linear_0_34450)"
                    d="M94.306 281.036c-.28 1.35-2.07 67.499 4.717 97.217.11.486-.138.981-.6 1.164-1.088.432-3.22 1.053-5.767 1.116a1.735 1.735 0 01-1.706-1.26c-1.955-6.899-11.306-41.457-12.257-74.392-1.061-36.803.013-1.251.013-1.251l1.043-22.732 14.557.141v-.003z"
                ></path>
                <path
                    fill="url(#paint33_linear_0_34450)"
                    d="M70.306 383.018s-1.239 2.176-2.471 7.973a1.802 1.802 0 001.565 2.173c1.883.204 4.78.468 7.104.477 1.07 0 1.917-.921 1.797-1.986-.237-2.125-1.005-5.612-3.458-8.346l-4.537-.288v-.003z"
                ></path>
                <path
                    fill="url(#paint34_linear_0_34450)"
                    d="M69.301 376.347l1.361 7.847s1.41 1.072 4.223.33l-.606-8.435-4.981.258h.003z"
                ></path>
                <path
                    fill="url(#paint35_linear_0_34450)"
                    d="M66.314 282.8c-6.112 34.853.432 86.288 2.708 96.365a1.569 1.569 0 001.254 1.203c1.058.186 2.798.345 4.522-.138a1.433 1.433 0 001.043-1.314c.396-8.127.3-58.031 5.872-77.699.282-.996.9-1.864 1.752-2.455l10.523-7.337.914-12.013-28.59 3.388h.002z"
                ></path>
                <path
                    fill="url(#paint36_linear_0_34450)"
                    d="M103.776 217.009c-17.319-.453-36.478 4.204-36.478 4.204-5.452 30.099-1.52 64.912-1.52 64.912 13.377 3.646 28.558-1.878 28.558-1.878 2.348-12.58 13.087-47.946 13.087-47.946 8.474-.969 15.468-3.346 21.241-6.523-4.331-5.123-6.334-11.605-7.195-15.434-6.141 1.846-12.349 2.803-17.69 2.665h-.003z"
                ></path>
                <path
                    fill="url(#paint37_linear_0_34450)"
                    d="M155.186 191.966c-1.683-2.073-3.845-1.119-3.845-1.119-2.651 10.749-16.101 19.359-29.872 23.5.861 3.829 2.864 10.314 7.195 15.434 22.911-12.604 26.525-37.815 26.525-37.815h-.003z"
                ></path>
                <path
                    fill="url(#paint38_linear_0_34450)"
                    d="M154.766 192.486c.174.567-1.899 1.41-3.089-.919-.033-1.11-.66-5.872.009-6.773 3.578-4.783 10.481-10.755 10.481-10.755 1.146 1.153.183 2.266.183 2.266l-3.353 3.43c.684 1.263 1.521 2.332 1.901 3.853.291 1.152.093 2.383-.497 3.424-.594 1.044-1.401 2.404-2.163 3.466-1.442 2.011-3.472 2.005-3.472 2.005v.003z"
                ></path>
                <path
                    fill="url(#paint39_linear_0_34450)"
                    d="M157.522 181.968l-3.05 2.538-.975 2.548 2.669 3.022s.957-5.063 1.641-6.155c.683-1.092.338-1.626-.285-1.953z"
                ></path>
                <path
                    fill="url(#paint40_linear_0_34450)"
                    d="M73.781 238.06l-6.483-16.847s-16.284 10.845-19.08 24.769c3.057.256 8.61 1.105 14.03 3.908 1.26-6.575 11.533-11.827 11.533-11.827v-.003z"
                ></path>
                <path
                    fill="url(#paint41_linear_0_34450)"
                    d="M87.771 253.989s-18.263 10.101-24.309 1.269c-1.256-1.833-1.541-3.646-1.211-5.368-5.42-2.803-10.973-3.653-14.03-3.908-.842 4.199-.46 8.673 1.965 13.216 10.55 19.755 39.948-.705 39.948-.705l-2.36-4.504h-.003z"
                ></path>
                <path
                    fill="url(#paint42_linear_0_34450)"
                    d="M86.365 202.77L80.7 218.666a.573.573 0 00.255.693c1.493.846 6.885 3.301 13.447-.777a2.703 2.703 0 001.262-1.921l1.916-13.786-11.218-.108.003.003z"
                ></path>
                <path
                    fill="url(#paint43_linear_0_34450)"
                    d="M99.934 187.015s4.508 12.559 3.686 17.156c-.819 4.598-8.319 4.195-14.832.393l-4.46-12.354c2.87-4.997 9.522-6.497 15.606-5.195z"
                ></path>
                <path
                    fill="url(#paint44_linear_0_34450)"
                    d="M94.42 176.191c-3.665.441-3.869 3.574-9.687 5.999-3.595 1.497-4.702.798-6.267 2.4-2.423 2.479-2.927 7.392-1.14 10.798 3.077 5.863 11.456 9.224 11.807 8.204.096-.276 2.039-3.604-.045-5.708-.534-.54-.64-1.377-.333-2.073a1.85 1.85 0 00-.087-1.618c-.903-1.677-.75-3.103-.513-3.607.963-2.052 5.938.357 10.826-2.401.273-.153 4.726-2.733 4.558-5.998-.171-3.331-5.092-6.482-9.116-5.999l-.003.003z"
                ></path>
                <path
                    fill="url(#paint45_linear_0_34450)"
                    d="M89.85 197.104s-4.313-.87-4.652 1.617c-.339 2.488 3.848 3.647 5.932 2.737l-1.284-4.354h.003z"
                ></path>
                <path
                    fill="url(#paint46_linear_0_34450)"
                    d="M84.037 269.951l9.95-34.769c.115-.396.45-.681.858-.729 1.803-.21 7.027-.801 13.057-1.311 7.264-.615 15.699-1.114 20.741-.69.716.06 1.148.819.83 1.464-2.867 5.804-14.658 29.412-20.563 37.145a1.022 1.022 0 01-.822.402l-23.082-.216a1.018 1.018 0 01-.969-1.296z"
                ></path>
                <path
                    fill="url(#paint47_linear_0_34450)"
                    d="M86.44 261.551s-1.386-5.702-.828-7.724c.558-2.023 1.643-4.625 5.254-4.045 3.61.579 7.869 2.1 7.869 2.1s-.216 2.635-2.96 1.786l1.7 1.317s-.243 2.11-2.56.981l1.583 1.747s-.996 1.731-2.702.621c-1.707-1.11-2.522 3.904-7.36 3.217h.003z"
                ></path>
                <path
                    fill="#91B3FA"
                    d="M94.911 245.385l-.345-.102 2.028-6.875a2.93 2.93 0 012.2-2.052c6.4-1.336 23.833-1.618 24.01-1.621l.006.36c-.174 0-17.574.285-23.94 1.615a2.567 2.567 0 00-1.928 1.8l-2.028 6.875h-.003z"
                ></path>
                <path
                    fill="url(#paint48_linear_0_34450)"
                    d="M87.666 213.273l-5.92-.591c-.288-.03-.593.132-.701.39-.597 1.434-2.31 5.894-2.082 6.038 4.634 2.86 9.417 2.007 9.417 2.007v-7.22c0-.324-.384-.594-.717-.627l.003.003z"
                ></path>
                <path
                    fill="url(#paint49_linear_0_34450)"
                    d="M96.807 213.525a.622.622 0 00-.312-.495.674.674 0 00-.597-.039l-1.185.504a.645.645 0 00-.338.333l-2.88 6.671c2.202 1.062 5.563-3.409 5.563-3.409l-.251-3.565z"
                ></path>
                <path
                    fill="url(#paint50_linear_0_34450)"
                    d="M88.383 221.12s1.886 16.166 2.018 15.869c.132-.294 1.751-17.063 1.751-17.063s-2.432.795-3.766.849v.342l-.003.003z"
                ></path>
                <path
                    fill="#BDD0FB"
                    d="M101.464 184.206h-.027a.169.169 0 01-.138-.192c.045-.267-.309-2.088-1.44-3.646-.968-1.338-2.222-2.13-3.727-2.358a.17.17 0 01-.141-.19.167.167 0 01.189-.141c1.595.241 2.924 1.081 3.946 2.491 1.203 1.657 1.557 3.55 1.497 3.895a.167.167 0 01-.165.138l.006.003z"
                ></path>
                <path
                    fill="url(#paint51_linear_0_34450)"
                    d="M450.35 398.124c0-.117-.006-.237-.036-.357-1.782-7.067-9.066-10.692-9.066-10.692l-3.506.276c-2.015 6.23-3.313 9.273-2.99 10.975.009.048.024.093.036.138 2.891.258 8.841.426 15.562-.34z"
                ></path>
                <path
                    fill="url(#paint52_linear_0_34450)"
                    d="M434.788 398.461c.156.567.576 1.011 1.113 1.122 4.111.864 10.649.168 13.393-.189.606-.078 1.047-.639 1.059-1.272-6.721.765-12.671.597-15.562.339h-.003z"
                ></path>
                <path
                    fill="url(#paint53_linear_0_34450)"
                    d="M444.133 381.617l-1.536 7.391c-.113.54-.527.948-1.031.993-.618.057-1.494.093-2.378-.039-.792-.117-1.344-.921-1.203-1.785l1.068-6.563h5.08v.003z"
                ></path>
                <path
                    fill="url(#paint54_linear_0_34450)"
                    d="M405.013 398.401c3.742-.105 5.676-.547 6.678-.955 0 .372 0 .75-.012 1.144-.012.42-.324.753-.705.753l-20.548-.132c-.657-.003-1.04-.765-.756-1.369 2.693.222 9.558.721 15.343.559z"
                ></path>
                <path
                    fill="url(#paint55_linear_0_34450)"
                    d="M389.67 397.842c.024-.051.045-.105.081-.156 1.815-2.538 6.436-7.589 15.571-9.783l4.381-.138s1.952 3.394 1.988 9.678c-1.002.408-2.936.849-6.678.954-5.785.163-12.647-.336-15.343-.558v.003z"
                ></path>
                <path
                    fill="url(#paint56_linear_0_34450)"
                    d="M410.516 381.121c-.048.328-.651 5.294-.882 7.221-.054.456-.387.813-.804.861-.747.09-1.952.171-3.011-.045-.57-.117-.983-.663-.983-1.303v-7.796l5.677 1.062h.003z"
                ></path>
                <path
                    fill="url(#paint57_linear_0_34450)"
                    d="M441.203 284.562s7.011 62.364 3.116 101.343c0 0-4.675 0-7.012-.78 0 0-7.284-60.975-9.641-78.425-.09-.658-1.029-.688-1.158-.036-2.908 14.68-14.328 72.246-15.687 77.681 0 0-3.895 1.56-7.011 0 0 0 6.232-83.413 10.907-98.225l26.486-1.561v.003z"
                ></path>
                <path
                    fill="url(#paint58_linear_0_34450)"
                    d="M455.226 212.064s-29.602-4.679-52.975 1.56l1.559 24.166s6.232 33.52 10.907 48.332c0 0 17.918 3.118 26.486-1.56 0 0 7.011-42.096 10.907-48.332 0 0 3.895-16.37 3.116-24.166z"
                ></path>
                <path
                    fill="url(#paint59_linear_0_34450)"
                    d="M434.662 190.763l2.948 19.956s-8.238 3.787-14.007-.162l1.241-14.083 9.818-5.711z"
                ></path>
                <path
                    fill="url(#paint60_linear_0_34450)"
                    d="M421.965 177.766c-.093.168-1.871 10.233-2.966 16.46a4.371 4.371 0 004.046 5.12l2.387.141a8.508 8.508 0 008.913-7.211l1.727-11.284s-11.852-7.319-14.107-3.226z"
                ></path>
                <path
                    fill="url(#paint61_linear_0_34450)"
                    d="M438.645 181.022c.915-1.14 1.712-2.979-.237-4.918-1.973-1.96-4.213-1.47-5.632-.813-.63.291-1.403.162-1.85-.366-.198-.234-.495-.396-.933-.345-.824.093-1.562-.454-1.661-1.279-.168-1.416-.921-3.082-3.422-3.565-4.585-.888-6.873 3.706-6.792 6.935.081 3.229 5.11 3.907 7.962 3.37 2.096-.393 3.907 1.45 4.72 2.455.297.366.405.843.3 1.299l-.726 3.118c.501.969.996 1.96 1.7 2.788.507.597 1.065.924 1.656 1.062.854-1.593 3.248-1.863 4.357-1.899a1.51 1.51 0 001.101-.522c.839-.964 2.15-3.109-.36-5.219-.624-.525-.696-1.467-.186-2.104l.003.003z"
                ></path>
                <path
                    fill="url(#paint62_linear_0_34450)"
                    d="M432.905 194.1s.099-5.629 2.375-6.16c2.276-.529 4.735 1.119 2.786 4.489-2.423 4.192-5.164 1.668-5.164 1.668l.003.003z"
                ></path>
                <path
                    fill="url(#paint63_linear_0_34450)"
                    d="M455.226 212.064s45.963 49.892-8.181 68.99v-3.898s20.254-17.15 4.675-40.536c0 0 1.946-22.219 3.506-24.556z"
                ></path>
                <path
                    fill="url(#paint64_linear_0_34450)"
                    d="M446.658 277.546s-7.011-4.678-10.127-3.118c-3.116 1.56-3.116 3.898-3.116 3.898s1.559 3.118 3.895 2.338c2.337-.78 7.792.78 10.128 0 0 0 .779-3.118-.78-3.118z"
                ></path>
                <path
                    fill="url(#paint65_linear_0_34450)"
                    d="M402.254 213.621s-47.91 48.332 6.231 67.433v-3.898s-20.254-17.15-4.675-40.536c0 0 1.556-19.101-1.559-22.996l.003-.003z"
                ></path>
                <path
                    fill="url(#paint66_linear_0_34450)"
                    d="M408.875 277.546s7.011-4.678 10.127-3.118c3.116 1.56 3.116 3.898 3.116 3.898s-1.559 3.118-3.895 2.338c-2.337-.78-7.791.78-10.128 0 0 0-.779-3.118.78-3.118z"
                ></path>
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_0_34450"
                    x1="-65.654"
                    x2="277.587"
                    y1="456.885"
                    y2="194.23"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4042E2"></stop>
                    <stop offset="1" stopColor="#4F52FF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint1_linear_0_34450"
                    x1="296.519"
                    x2="282.106"
                    y1="-135.94"
                    y2="-26.098"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint2_linear_0_34450"
                    x1="280.38"
                    x2="312.813"
                    y1="87.65"
                    y2="-141.033"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4042E2"></stop>
                    <stop offset="1" stopColor="#4F52FF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint3_linear_0_34450"
                    x1="130.376"
                    x2="193.839"
                    y1="379.825"
                    y2="-403.48"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4042E2"></stop>
                    <stop offset="1" stopColor="#4F52FF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint4_linear_0_34450"
                    x1="180.244"
                    x2="243.71"
                    y1="383.864"
                    y2="-399.441"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4042E2"></stop>
                    <stop offset="1" stopColor="#4F52FF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint5_linear_0_34450"
                    x1="230.115"
                    x2="293.578"
                    y1="387.903"
                    y2="-395.399"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4042E2"></stop>
                    <stop offset="1" stopColor="#4F52FF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint6_linear_0_34450"
                    x1="279.984"
                    x2="343.446"
                    y1="391.945"
                    y2="-391.36"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4042E2"></stop>
                    <stop offset="1" stopColor="#4F52FF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint7_linear_0_34450"
                    x1="329.852"
                    x2="393.317"
                    y1="395.985"
                    y2="-387.318"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4042E2"></stop>
                    <stop offset="1" stopColor="#4F52FF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint8_linear_0_34450"
                    x1="379.723"
                    x2="443.185"
                    y1="400.027"
                    y2="-383.278"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4042E2"></stop>
                    <stop offset="1" stopColor="#4F52FF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint9_linear_0_34450"
                    x1="151.086"
                    x2="398.568"
                    y1="187.369"
                    y2="187.369"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#DAE3FE"></stop>
                    <stop offset="1" stopColor="#E9EFFD"></stop>
                </linearGradient>
                <linearGradient
                    id="paint10_linear_0_34450"
                    x1="525.405"
                    x2="498.699"
                    y1="330.695"
                    y2="336.862"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint11_linear_0_34450"
                    x1="117.13"
                    x2="386.283"
                    y1="432.202"
                    y2="292.413"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FE7062"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint12_linear_0_34450"
                    x1="477.946"
                    x2="484.48"
                    y1="228.964"
                    y2="302.776"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint13_linear_0_34450"
                    x1="138.955"
                    x2="145.493"
                    y1="258.993"
                    y2="332.799"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint14_linear_0_34450"
                    x1="154.316"
                    x2="145.623"
                    y1="243.69"
                    y2="283.257"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FEB3B1"></stop>
                </linearGradient>
                <linearGradient
                    id="paint15_linear_0_34450"
                    x1="433.694"
                    x2="425.968"
                    y1="125.719"
                    y2="173.008"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FEB3B1"></stop>
                </linearGradient>
                <linearGradient
                    id="paint16_linear_0_34450"
                    x1="499.867"
                    x2="492.141"
                    y1="136.531"
                    y2="183.818"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FEB3B1"></stop>
                </linearGradient>
                <linearGradient
                    id="paint17_linear_0_34450"
                    x1="447.311"
                    x2="441.518"
                    y1="285.186"
                    y2="314.62"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint18_linear_0_34450"
                    x1="213.273"
                    x2="206.514"
                    y1="272.955"
                    y2="316.863"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint19_linear_0_34450"
                    x1="424.154"
                    x2="378.814"
                    y1="285.018"
                    y2="308.397"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint20_linear_0_34450"
                    x1="132.868"
                    x2="226.65"
                    y1="352.826"
                    y2="316.426"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint21_linear_0_34450"
                    x1="504.237"
                    x2="395.57"
                    y1="70.858"
                    y2="64.545"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4042E2"></stop>
                    <stop offset="1" stopColor="#4F52FF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint22_linear_0_34450"
                    x1="501.702"
                    x2="486.583"
                    y1="34.423"
                    y2="66.879"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4042E2"></stop>
                    <stop offset="1" stopColor="#4F52FF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint23_linear_0_34450"
                    x1="443.236"
                    x2="446.597"
                    y1="64.942"
                    y2="163.455"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4042E2"></stop>
                    <stop offset="1" stopColor="#4F52FF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint24_linear_0_34450"
                    x1="468.898"
                    x2="510.625"
                    y1="137.208"
                    y2="233.698"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4042E2"></stop>
                    <stop offset="1" stopColor="#4F52FF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint25_linear_0_34450"
                    x1="477.636"
                    x2="519.366"
                    y1="133.43"
                    y2="229.922"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4042E2"></stop>
                    <stop offset="1" stopColor="#4F52FF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint26_linear_0_34450"
                    x1="383.947"
                    x2="379.383"
                    y1="-448.771"
                    y2="-517.472"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint27_linear_0_34450"
                    x1="1272.47"
                    x2="1337.92"
                    y1="-212.118"
                    y2="-233.354"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint28_linear_0_34450"
                    x1="413.223"
                    x2="487.87"
                    y1="138.104"
                    y2="14.274"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FE7062"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint29_linear_0_34450"
                    x1="397.929"
                    x2="472.576"
                    y1="128.885"
                    y2="5.056"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FE7062"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint30_linear_0_34450"
                    x1="93.279"
                    x2="95.766"
                    y1="129.428"
                    y2="184.073"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint31_linear_0_34450"
                    x1="92.771"
                    x2="99.33"
                    y1="380.692"
                    y2="380.754"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FEB3B1"></stop>
                </linearGradient>
                <linearGradient
                    id="paint32_linear_0_34450"
                    x1="157.06"
                    x2="127.649"
                    y1="252.501"
                    y2="286.091"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint33_linear_0_34450"
                    x1="61.092"
                    x2="63.579"
                    y1="130.894"
                    y2="185.536"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint34_linear_0_34450"
                    x1="69.141"
                    x2="74.803"
                    y1="380.133"
                    y2="380.186"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FEB3B1"></stop>
                </linearGradient>
                <linearGradient
                    id="paint35_linear_0_34450"
                    x1="147.287"
                    x2="117.875"
                    y1="243.939"
                    y2="277.529"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint36_linear_0_34450"
                    x1="87.045"
                    x2="32.403"
                    y1="248.224"
                    y2="361.629"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FE7062"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint37_linear_0_34450"
                    x1="121.375"
                    x2="154.874"
                    y1="209.763"
                    y2="210.078"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FEB3B1"></stop>
                </linearGradient>
                <linearGradient
                    id="paint38_linear_0_34450"
                    x1="174.786"
                    x2="164.881"
                    y1="159.986"
                    y2="173.784"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FEB3B1"></stop>
                </linearGradient>
                <linearGradient
                    id="paint39_linear_0_34450"
                    x1="173.644"
                    x2="121.432"
                    y1="170.852"
                    y2="217.631"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FEB3B1"></stop>
                </linearGradient>
                <linearGradient
                    id="paint40_linear_0_34450"
                    x1="63.141"
                    x2="8.502"
                    y1="236.707"
                    y2="350.112"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FE7062"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint41_linear_0_34450"
                    x1="48.276"
                    x2="81.27"
                    y1="250.424"
                    y2="263.612"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FEB3B1"></stop>
                </linearGradient>
                <linearGradient
                    id="paint42_linear_0_34450"
                    x1="95.034"
                    x2="81.525"
                    y1="201.548"
                    y2="229.45"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FEB3B1"></stop>
                </linearGradient>
                <linearGradient
                    id="paint43_linear_0_34450"
                    x1="-917.319"
                    x2="-893.184"
                    y1="-406.352"
                    y2="-392.007"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FEB3B1"></stop>
                </linearGradient>
                <linearGradient
                    id="paint44_linear_0_34450"
                    x1="86.08"
                    x2="92.956"
                    y1="165.118"
                    y2="204.317"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint45_linear_0_34450"
                    x1="-920.367"
                    x2="-896.232"
                    y1="-401.216"
                    y2="-386.872"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FEB3B1"></stop>
                </linearGradient>
                <linearGradient
                    id="paint46_linear_0_34450"
                    x1="118.278"
                    x2="103.567"
                    y1="279.538"
                    y2="244.135"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint47_linear_0_34450"
                    x1="102.777"
                    x2="98.574"
                    y1="221.087"
                    y2="233.689"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FEB3B1"></stop>
                </linearGradient>
                <linearGradient
                    id="paint48_linear_0_34450"
                    x1="80.751"
                    x2="67.54"
                    y1="229.322"
                    y2="271.629"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FE7062"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint49_linear_0_34450"
                    x1="90.089"
                    x2="76.878"
                    y1="232.239"
                    y2="274.546"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FE7062"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint50_linear_0_34450"
                    x1="88.383"
                    x2="92.149"
                    y1="228.46"
                    y2="228.46"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#DAE3FE"></stop>
                    <stop offset="1" stopColor="#E9EFFD"></stop>
                </linearGradient>
                <linearGradient
                    id="paint51_linear_0_34450"
                    x1="440.6"
                    x2="448.708"
                    y1="417.012"
                    y2="336.289"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4042E2"></stop>
                    <stop offset="1" stopColor="#4F52FF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint52_linear_0_34450"
                    x1="442.489"
                    x2="443.991"
                    y1="402.236"
                    y2="327.514"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4042E2"></stop>
                    <stop offset="1" stopColor="#4F52FF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint53_linear_0_34450"
                    x1="439.839"
                    x2="442.964"
                    y1="374.505"
                    y2="401.785"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FEB3B1"></stop>
                </linearGradient>
                <linearGradient
                    id="paint54_linear_0_34450"
                    x1="401.069"
                    x2="399.568"
                    y1="419.53"
                    y2="344.808"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4042E2"></stop>
                    <stop offset="1" stopColor="#4F52FF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint55_linear_0_34450"
                    x1="411.277"
                    x2="403.17"
                    y1="502.615"
                    y2="421.892"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4042E2"></stop>
                    <stop offset="1" stopColor="#4F52FF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint56_linear_0_34450"
                    x1="406.929"
                    x2="409.857"
                    y1="377.994"
                    y2="403.514"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FEB3B1"></stop>
                </linearGradient>
                <linearGradient
                    id="paint57_linear_0_34450"
                    x1="443.926"
                    x2="501.569"
                    y1="307.027"
                    y2="191.223"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4042E2"></stop>
                    <stop offset="1" stopColor="#4F52FF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint58_linear_0_34450"
                    x1="619.786"
                    x2="528.842"
                    y1="459.667"
                    y2="356.185"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint59_linear_0_34450"
                    x1="429.183"
                    x2="431.286"
                    y1="185.017"
                    y2="222.828"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FEB3B1"></stop>
                </linearGradient>
                <linearGradient
                    id="paint60_linear_0_34450"
                    x1="418.23"
                    x2="419.37"
                    y1="405.134"
                    y2="378.518"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FEB3B1"></stop>
                </linearGradient>
                <linearGradient
                    id="paint61_linear_0_34450"
                    x1="440.685"
                    x2="418.542"
                    y1="185.92"
                    y2="173.72"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint62_linear_0_34450"
                    x1="426.733"
                    x2="427.873"
                    y1="405.5"
                    y2="378.885"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FEB3B1"></stop>
                </linearGradient>
                <linearGradient
                    id="paint63_linear_0_34450"
                    x1="630.168"
                    x2="539.224"
                    y1="450.541"
                    y2="347.059"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint64_linear_0_34450"
                    x1="445.416"
                    x2="443.765"
                    y1="258.961"
                    y2="265.713"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FEB3B1"></stop>
                </linearGradient>
                <linearGradient
                    id="paint65_linear_0_34450"
                    x1="601.382"
                    x2="510.438"
                    y1="475.835"
                    y2="372.356"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint66_linear_0_34450"
                    x1="420.901"
                    x2="417.748"
                    y1="257.986"
                    y2="268.938"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FEB3B1"></stop>
                </linearGradient>
                <clipPath id="clip0_0_34450">
                    <path fill="#fff" d="M0 0H525.573V400H0z"></path>
                </clipPath>
            </defs>
        </svg>
    );
}

export default MainImg;
